import React from 'react'
import { Campaign } from '@/services/api/campaign'
import useSiteAssets from '@/services/hooks/useSiteAssets'
import Type from '../Type'
import Footer from './Footer'
import PriorRaises from './PriorRaises'
import Progress from './Progress'
import SellingFast from './SellingFast'

interface Props {
  campaign: Campaign
  url: string
}

const CurrentlyFundingSection: React.FC<Props> = ({ campaign, url }) => {
  const clarificationSymbol = campaign.isSellingFast ? '†' : ''
  const { fundingCtaText } = useSiteAssets()

  return (
    <>
      <Progress campaign={campaign} />
      <PriorRaises campaign={campaign} />
      <SellingFast campaign={campaign} className="text-core-gray-700" />

      <Footer cta={fundingCtaText} url={url}>
        <Type as="p" variant="caption-sm" className="text-core-gray-600">
          {Number(campaign.backers).toLocaleString()} investors
        </Type>
        <Type as="p" variant="caption-sm" className="text-core-gray-600">
          {Number(campaign.timeRemaining.timeRemainingValue).toLocaleString()}
          <span className="ml-1 lowercase">
            {`${campaign.timeRemaining.timeRemainingDimension} left`}{' '}
            {clarificationSymbol}
          </span>
        </Type>
      </Footer>
    </>
  )
}

export default CurrentlyFundingSection
